import { gridItems } from "../data/index";
import { BentoGrid, BentoGridItem } from "../ui/BentoGrid";
import "./grid.css"

const Grid = ( {aboutRef, scrollToElement} ) => {
  return (
    <section ref={aboutRef} id="about">
      <h1 className="heading"  >
        About <span className="highlighted-text"> Us</span>
      </h1>
      <BentoGrid className="gridz">
        {gridItems.map((item, i) => (
          <BentoGridItem
            id={item.id}
            key={i}
            title={item.title}
            description={item.description}
            className={item.className}
            img={item.img}
            imgClassName={item.imgClassName}
            titleClassName={item.titleClassName}
            spareImg={item.spareImg}
            scrollToElement={scrollToElement}
          />
        ))}
      </BentoGrid>
    </section>
  );
};

export default Grid;
